import { Upload, Gear } from 'react-bootstrap-icons';

import T from 'utils/useLocalizer';
import { buttons } from 'utils/resources';
import { useNavigate } from 'react-router-dom';
import { pageRoutes } from 'config/router/pageRoutes';
import InlineSpinner from 'components/ui/spinner/InlineSpinner';
interface Props {
    exportOrderToCsvFile: () => any,
    isLoading: boolean
}

const OrderToolbar = ({ exportOrderToCsvFile, isLoading = false }: Props) => {
    const navigate = useNavigate();
    
    const resources = {
        exportButton: T(buttons.export),
        settingsButton: T('order.setting.btn')
    };

    const exportOrdersInCsvFileHandler = () => {
        exportOrderToCsvFile()
    }

    return (
        <div className="d-flex flex-column my-3">
            <div className="flex-fill text-end">
                <button type='button'
                    onClick={exportOrdersInCsvFileHandler}
                    className="btn btn-outline-secondary text-black me-2 "
                    disabled={isLoading}
                >
                    <Upload className='me-2' />
                    {resources.exportButton}
                    {isLoading && (
                        <span className="ms-2">
                            <InlineSpinner small />
                        </span>
                    )}
                </button>

                <button type='button'
                    onClick={() => navigate(pageRoutes.orderSettings)}
                    className="btn btn-outline-secondary text-black">
                    <Gear className='me-2' />
                    {resources.settingsButton}
                </button>

            </div>
        </div>
    );
};

export default OrderToolbar;
